import { render, staticRenderFns } from "./oodrive-success.vue?vue&type=template&id=20c472d1&"
import script from "./oodrive-success.vue?vue&type=script&lang=js&"
export * from "./oodrive-success.vue?vue&type=script&lang=js&"
import style0 from "./oodrive-success.vue?vue&type=style&index=0&id=20c472d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports